import { useState } from "react";
import { OverlayTrigger, Tooltip, Table } from "react-bootstrap";
import { currencyFormat } from "../../../helpers/numericFields";
import styles from './AdvancePaymentDetails.module.css'
import { EditAdvancePayment } from "./EditAdvancePayment";
import { Link } from "react-router-dom";
import { ModalPaymentImage } from "../../ui/controls/ModalPaymentImage";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import { Col, Row, Card } from "react-bootstrap";

export const AdvancePaymentDetails = ({ pendingPayments }) => {
  const [editAdvancePayment, setEditAddAdvancePayment] = useState(false);
  const [viewImage, setViewImage] = useState(false);
  const [paymentSelected, setPaymentSelected] = useState({});

  const edit2 = (payment) => {
    setEditAddAdvancePayment(true);
    setPaymentSelected(payment)
  }

  const viewImage2 = (payment) => {
    setViewImage(true);
    setPaymentSelected(payment);
  }

  const columns = [
    {
      name: "Pago #",
      selector: (row, index) => [index + 1],
      width: "80px",
      cell: (row, index) => <span className="text-muted fs-15 w-semibold text-center w-100">{index + 1}</span>
    },
    {
      name: "Fecha",
      selector: row => [row.date],
      sortable: true,
      width: "120px",
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.date}</span>
    },
    {
      name: "Grupo",
      selector: row => [row.groupName],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.groupName}</span>
    },
    {
      name: "Cliente",
      selector: row => [row.customer],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.customer}</span>
    },
    {
      name: "#Exp",
      selector: row => [row.id],
      width:"85px",
      cell: row => <span className="text-center w-100">
        <OverlayTrigger placement="top" overlay={<Tooltip >Ver Expediente</Tooltip>}>
          <Link to={`/panel/expedienteIndividual?id=${row.idIndividualFile}`} className="btn btn-primary btn-sm rounded-11 me-2" ><span className="fs-15 fw-semibold text-center">{row.idIndividualFile}</span></Link>
        </OverlayTrigger>
      </span>
    }, 
    {
      name: "Metodo",
      selector: row => [row.paymentMethod],
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.paymentMethod}</span>
    },
    {
      name: "Forma De Pago",
      selector: row => [row.paymentWay],
      width: "200px",
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.paymentWay}</span>
    },
    {
      name: "Referencia",
      selector: row => [row.reference],
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.reference}</span>
    },
    {
      name: "Comprobante",
      selector: row => [row.email],
      cell: row => <span className="text-center w-100">{row.image === 1
                        ? <i className={`fa fa-image ${styles.edit}`} onClick={() => viewImage2(row)}></i>
                        : null}</span>
    },
    {
      name: "Monto",
      selector: row => [row.amount],
      cell: row => <span className="text-muted fs-15 fw-semibold">{currencyFormat(row.amount)}</span>
    },
    {
      name: " Fecha Evento",
      selector: row => [row.date],
      sortable: true,
      width: "120px",
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.startDate}</span>
    },
    {
      name: "Notas",
      selector: row => [row.notes],
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.notes}</span>
    },
    {
      name: "Editar",
      width: "85px",
      cell: row => <span className="text-center w-100">
        <i className={`fe fe-edit .hover`} role='button' onClick={() => edit2(row)}></i>
      </span>
    },
  ]
  const tableDatas = {
    columns,
    data: pendingPayments,
  };

  return (
    <div style={{ marginTop: 20, marginBottom: 50, border: "1 solid gray", background: "white", padding: 20 }}>
      <Row>
        <Col sm={12} className="col-12">
          <Card>
            <Card.Header>
              <h3 className="card-title mb-0">Pagos pendientes por aprobar</h3>
            </Card.Header>
            <Card.Body>
              <div className="dataTable">
                <div className="table-responsive">
                  <DataTableExtensions {...tableDatas} >
                    <DataTable
                      columns={columns}
                      data={pendingPayments}
                      noHeader
                      defaultSortField="id"
                      defaultSortAsc={false}
                      striped={true}
                      center={true}
                      persistTableHead
                      pagination
                      highlightOnHover />
                  </DataTableExtensions>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <EditAdvancePayment payment={paymentSelected}
        isOpen={editAdvancePayment} setIsOpen={setEditAddAdvancePayment} />
      <ModalPaymentImage code={paymentSelected.code} id={paymentSelected.id} isOpen={viewImage} setIsOpen={setViewImage} />
      <div className={styles.total}>Total: {
        currencyFormat(pendingPayments.reduce((a, b) => a += b.amount, 0))}
      </div>
    </div>
  )
}
